
import Vue from 'vue'
import Swal from 'sweetalert2'
import axios from 'axios'
import { ParsedQuery } from 'query-string'

export default Vue.extend({
  data: () => ({
    ipns: '',
    filename: ''
  }),

  methods: {
    /**
     * User wants to open a IPNS
     */
    async open() {
      try {
        if (!this.$ipfs.api) {
          throw new Error('IPFS API undefined!')
        }

        const { data } = await axios.get('https://ipfs.io/api/v0/name/resolve', {
          params: {
            arg: `/ipns/${this.ipns}`,
            recursive: true,
            'dht-timeout': '30000ms'
          }
        })

        const cid = data.Path.substring(6)

        const query: ParsedQuery = {
          cid,
          name: this.filename
        }

        this.$router.push({
          path: '/explorer',
          query
        })
      } catch (err: any) {
        Swal.fire({
          title: 'A problem has occurred',
          text: err.message,
          icon: 'error'
        })
      }
    }
  }
})
